// extracted by mini-css-extract-plugin
export default {"modifierNoteAndComment":"SplitEvenly_modifierNoteAndComment__unGJk","hyphenStyle":"SplitEvenly_hyphenStyle__Yhgl4","h81":"SplitEvenly_h81__s71oR"};